import { s3ProgressConfig } from "../utils/uploadProgress";
import axios from "axios";
import { withLinkCache } from "../utils/mediaLinkCache";
import { api } from "./axiosClient";

export const organisationApi = {
  searchOrganisations: async (payload: any) => {
    const response = await api.post("/group/search", payload);
    return response.data;
  },

  createOrganisation: async (data: any) => {
    console.log("data", data);
    const response = await api.post("/group/create", data);
    return response.data;
  },

  updateOrganisation: async (data: any) => {
    const response = await api.post("/group/edit", data);
    return response.data;
  },

  removeOrganisation: async (id: string) => {
    return await api.post("/group/remove", { id });
  },

  /** Undoes a removal (Super Admin only); the organisation comes back active or inactive, as it was. */
  restoreOrganisation: async (id: string) => {
    return await api.post("/group/remove", { id, undo: true });
  },

  changeStatusOrganisation: async (data: {
    organisationId: string;
    isActive: boolean;
  }) => {
    return await api.post("/group/changestatus", data);
  },

  activateOrganisation: async (id: string) => {
    return await api.post("/group/activate", { id });
  },

  deactivateOrganisation: async (id: string) => {
    return await api.post("/group/deactivate", { id });
  },

  initUpload: async (ids: string[], groupId?: string) => {
    const response = await api.post("/group/initupload", { ids, groupId });
    return response.data;
  },

  uploadToS3: async (s3Url: string, file: File) => {
    return await axios.put(s3Url, file, {
      ...s3ProgressConfig(file),
      headers: {
        "Content-Type": file.type,
      },
    });
  },

  uploadMedia: async (_organisationId: string, medias: any[]) => {
    return await api.post("/group/uploadmedia", {
      medias,
    });
  },

  getMediaLink: async (ids: string[], size: number = 3, groupId?: string) => {
    // Reused until near expiry so the browser cache can hit (mediaLinkCache).
    return withLinkCache(
      ids,
      `group:${size}:${groupId ?? ""}`,
      async (missing) => {
        const response = await api.post("/group/getmedialink", {
          ids: missing,
          size,
          groupId,
        });
        return response.data;
      },
    );
  },

  /**
   * Backend-authoritative organisation switch for Super Admins. Mirrors the
   * shape of /Auth/login's response (token/refreshToken/groupId/companyName)
   * since a switch is effectively re-authenticating into a different
   * tenant's context — the backend must validate access and issue a fresh
   * token rather than the client just changing a local organisationId.
   */
  switchOrganisation: async (
    organisationId: string,
  ): Promise<{
    token: string;
    refreshToken?: string;
    groupId: string;
    companyName: string;
  }> => {
    const response = await api.post("/Auth/switch-organisation", {
      organisationId,
    });
    return response.data;
  },
};
